import {
  AnswerQuestionnaireIcon,
  BrowseEligibleIcon,
  FilledStethoscope,
  GetVaccinatedIcon,
  ReviewLifestyleIcon,
  TncIcon,
} from '@shared/assets';
import { NoPaddingFilledInfoIcon } from '@shared/assets-icon';
import type { IChasInfo } from '@shared/services/healthiersg/healthplan/types/getPatientInfo.types';

export const NOTIFICATION_KEY = 'notification';

export const BMI_FORM_MAPPER = {
  bmi: {
    linkId: 'bmi.1.3',
    type: 'bmi',
  },
  height: {
    linkId: 'bmi.1.1',
    type: 'height',
  },
  weight: {
    linkId: 'bmi.1.2',
    type: 'weight',
  },
};

export const BMI_VALIDATION_MAPPER = {
  [BMI_FORM_MAPPER.height.linkId]: {
    errorMsg: 'questionnaireLibrary.basicHealthInformation.validFormatHeightMsg',
    max: 300,
    min: 1,
  },
  [BMI_FORM_MAPPER.weight.linkId]: {
    errorMsg: 'questionnaireLibrary.basicHealthInformation.validFormatWeightMsg',
    max: 999.9,
    min: 1,
  },
};

export const SubmittedBy = {
  SELF_RECORDED: 'patient',
} as const;

export const VACCINATE_INFO_URL = 'https://www.healthhub.sg/programmes/vaccinate';

export const CHAS_CODES_MAPPING: IChasInfo[] = [
  {
    bgcolor: '#2E8CB4', // blue
    buttonOkText: 'View external link',
    code: 'Blue',
    fontcolor: '#FFFFFF', // white
    isDisplay: true,
    promptMessage:
      'You will be redirected to <b>chas.sg/chas-subsidies</b> for your for more information on CHAS subsidies. Please exit the browser and relaunch the HealthHub app to return to Healthier SG.',
    showArrow: false,
    title: 'CHAS Blue',
    url: 'https://chas.sg/chas-subsidies',
  },
  {
    bgcolor: '#EE8F38', // orange
    buttonOkText: 'View external link',
    code: 'Orange',
    fontcolor: '#FFFFFF', // white
    isDisplay: true,
    promptMessage:
      'You will be redirected to <b>chas.sg/chas-subsidies</b> for your for more information on CHAS subsidies. Please exit the browser and relaunch the HealthHub app to return to Healthier SG.',
    showArrow: false,
    title: 'CHAS Orange',
    url: 'https://chas.sg/chas-subsidies',
  },
  {
    bgcolor: '#31A67D', // green
    buttonOkText: 'View external link',
    code: 'Green',
    fontcolor: '#FFFFFF', // white
    isDisplay: true,
    promptMessage:
      'You will be redirected to <b>chas.sg/chas-subsidies</b> for your for more information on CHAS subsidies. Please exit the browser and relaunch the HealthHub app to return to Healthier SG.',
    showArrow: false,
    title: 'CHAS Green',
    url: 'https://chas.sg/chas-subsidies',
  },
  {
    bgcolor: '#2E8CB4', // blue
    buttonOkText: 'View external link',
    code: 'PG Blue',
    fontcolor: '#FFFFFF', // white
    isDisplay: true,
    promptMessage:
      'You will be redirected to <b>chas.sg/chas-subsidies</b> for your for more information on CHAS subsidies. Please exit the browser and relaunch the HealthHub app to return to Healthier SG.',
    showArrow: false,
    title: 'PG Blue',
    url: 'https://chas.sg/chas-subsidies',
  },
  {
    bgcolor: '#EE8F38', // orange
    buttonOkText: 'View external link',
    code: 'PG Orange',
    fontcolor: '#FFFFFF', // white
    isDisplay: true,
    promptMessage:
      'You will be redirected to <b>chas.sg/chas-subsidies</b> for your for more information on CHAS subsidies. Please exit the browser and relaunch the HealthHub app to return to Healthier SG.',
    showArrow: false,
    title: 'PG Orange',
    url: 'https://chas.sg/chas-subsidies',
  },
  {
    bgcolor: '#31A67D', // green
    buttonOkText: 'View external link',
    code: 'PG Green',
    fontcolor: '#FFFFFF', // white
    isDisplay: true,
    promptMessage:
      'You will be redirected to <b>chas.sg/chas-subsidies</b> for your for more information on CHAS subsidies. Please exit the browser and relaunch the HealthHub app to return to Healthier SG.',
    showArrow: false,
    title: 'PG Green',
    url: 'https://chas.sg/chas-subsidies',
  },
  {
    bgcolor: '#2E8CB4', // blue
    buttonOkText: 'View external link',
    code: 'MG Blue',
    fontcolor: '#FFFFFF', // white
    isDisplay: true,
    promptMessage:
      'You will be redirected to <b>chas.sg/chas-subsidies</b> for your for more information on CHAS subsidies. Please exit the browser and relaunch the HealthHub app to return to Healthier SG.',
    showArrow: false,
    title: 'MG Blue',
    url: 'https://chas.sg/chas-subsidies',
  },
  {
    bgcolor: '#EE8F38', // orange
    buttonOkText: 'View external link',
    code: 'MG Orange',
    fontcolor: '#FFFFFF', // white
    isDisplay: true,
    promptMessage:
      'You will be redirected to <b>chas.sg/chas-subsidies</b> for your for more information on CHAS subsidies. Please exit the browser and relaunch the HealthHub app to return to Healthier SG.',
    showArrow: false,
    title: 'MG Orange',
    url: 'https://chas.sg/chas-subsidies',
  },
  {
    bgcolor: '#31A67D', // green
    buttonOkText: 'View external link',
    code: 'MG Green',
    fontcolor: '#FFFFFF', // white
    isDisplay: true,
    promptMessage:
      'You will be redirected to <b>chas.sg/chas-subsidies</b> for your for more information on CHAS subsidies. Please exit the browser and relaunch the HealthHub app to return to Healthier SG.',
    showArrow: false,
    title: 'MG Green',
    url: 'https://chas.sg/chas-subsidies',
  },
  {
    bgcolor: '#007AAF', // blue
    buttonOkText: 'Apply for CHAS',
    code: 'PG',
    fontcolor: '#FFFFFF', // white
    image: NoPaddingFilledInfoIcon,
    imageClassName:
      'size-2.5 [&_circle:first-child]:fill-none [&_circle:first-child]:stroke-white [&_circle:last-child]:fill-white [&_path]:stroke-white',
    isDisplay: true,
    promptMessage:
      'You will be redirected to <b>www.chas.sg</b> for your CHAS registration. When completed, please exit the browser and relaunch the HealthHub app to return to Healthier SG.',
    showArrow: true,
    title: 'Apply for CHAS',
    url: 'https://chas.moh.gov.sg/home/welcome',
  },
  {
    bgcolor: '#007AAF', // blue
    buttonOkText: 'Apply for CHAS',
    code: 'MG',
    fontcolor: '#FFFFFF', // white
    image: NoPaddingFilledInfoIcon,
    imageClassName:
      'size-2.5 [&_circle:first-child]:fill-none [&_circle:first-child]:stroke-white [&_circle:last-child]:fill-white [&_path]:stroke-white',
    isDisplay: true,
    promptMessage:
      'You will be redirected to <b>www.chas.sg</b> for your CHAS registration. When completed, please exit the browser and relaunch the HealthHub app to return to Healthier SG.',
    showArrow: true,
    title: 'Apply for CHAS',
    url: 'https://chas.moh.gov.sg/Home/Welcome',
  },
  {
    bgcolor: '',
    buttonOkText: '',
    code: 'PA',
    fontcolor: '',
    isDisplay: false,
    promptMessage: '',
    showArrow: false,
    title: '',
    url: '',
  },
  {
    bgcolor: '#007AAF', // blue
    buttonOkText: 'Apply for CHAS',
    code: 'NA',
    fontcolor: '#FFFFFF', // white
    image: NoPaddingFilledInfoIcon,
    imageClassName:
      'size-2.5 [&_circle:first-child]:fill-none [&_circle:first-child]:stroke-white [&_circle:last-child]:fill-white [&_path]:stroke-white',
    isDisplay: true,
    promptMessage:
      'You will be redirected to <b>www.chas.sg</b> for your CHAS registration. When completed, please exit the browser and relaunch the HealthHub app to return to Healthier SG.',
    showArrow: true,
    title: 'Apply for CHAS',
    url: 'https://chas.moh.gov.sg/Home/Welcome',
  },
];

export const ORG_TYPE_POLY = 'poly';

export const ORG_TYPE_GP = 'gp';

export const SMOKING_CESSATION_GOAL = 'Group-8';

export const SMOKING_CESSATION_GROUP_CODE = 'Group-8';

export const SMOKING_CESSATION_GOAL_G2 = 'GM002';

export const SMOKING_GOAL_TEXT = 'Quit smoking by';

export const QuestionnaireType = {
  ONBOARDING: 1,
  SMOKING: 2,
} as const;

export type QuestionnaireTypeType = (typeof QuestionnaireType)[keyof typeof QuestionnaireType];

export const ITEMS_PER_PAGE_COUNT = 10;

export const HEALTHPLAN_SUMMARY_IMAGES = [
  { name: 'group1.png', value: TncIcon },
  { name: 'group2.png', value: AnswerQuestionnaireIcon },
  { name: 'group3.png', value: BrowseEligibleIcon },
  { name: 'group4.png', value: FilledStethoscope },
  { name: 'group5.png', value: GetVaccinatedIcon },
  { name: 'group6.png', value: ReviewLifestyleIcon },
  { name: 'group7.png', value: ReviewLifestyleIcon },
  { name: 'group8.png', value: FilledStethoscope },
  { name: 'group9.png', value: FilledStethoscope },
];

export const TEXT_LIMIT_COUNT = 150;

export const ONE_THING_TO_START_WORKING_ON_TODAY = 'Group-1';

export const AEROBIC_EXERCISE_CODE = 'G8-1';

export const NAIS_LINK =
  'https://isomer-user-content.by.gov.sg/18/abda18d6-75b8-4ce2-9085-58905e6e75b6/NAIS_Sept%202025.pdf';

export const HPV_CODE = 'A-HPV';

export const PNEUMOCCOCAL_CODE = {
  PCV20: 'A-PCV20',
  PPSV: 'A-PPSV',
  PNC: 'A-PNC',
} as const;

export type PneumococcalCodeType = (typeof PNEUMOCCOCAL_CODE)[keyof typeof PNEUMOCCOCAL_CODE];

export const RECOMMENDED_EXERCISE_GROUP = 'Group-6';

export const RECOMMENDED_DIETARY_ADVICE_GROUP = 'Group-7';

export const ADDITIONAL_HEALTH_GUIDANCE_GROUP = 'Group-10';

export const RECOMMENDED_VACCINATION_GROUP = 'Group-5';

export const ArticleModuleEnum = {
  LIFE_STYLE_ACTIONS: 'Lifestyle Action',
  LIVE_HEALTHY: 'Live Healthy',
  SMOKING: 'Smoking',
  VACCINATION: 'Vaccination',
} as const;

export const RESIDENTIAL_STATUS = {
  CITIZEN: 'C',
  PR: 'P',
};

export const COLORECTAL_CANCER_SCREENING = 'Colorectal Cancer Screening';
export const HSG_SERVICE_TYPE_ID = '111002';
export const HSG_SERVICE_TYPE_ID_HAS = '34';
export const QUIT_LINE_CONTACT_NUMBER = '18004382000';
export const IQUIT_PROGRAMME = 'https://go.gov.sg/iquitprogramme';
export const MOH_HOTLINE = '63259220';
export const CERVICAL_CANCER = 'cervical_cancer';

export const ErrorCode = {
  HS0001: 'HS0001',
  HS0002: 'HS0002',
  HS0003: 'HS0003',
  HS0004: 'HS0004',
  HS0005: 'HS0005',
  HS0006: 'HS0006',
  HS0007: 'HS0007',
  HS0008: 'HS0008',
  HS0009: 'HS0009',
  HS0010: 'HS0010',
  HS0011: 'HS0011',
  HS0012: 'HS0012',
  HS0013: 'HS0013',
  HS0014: 'HS0014',
  LB0004: 'LB0004',
  LB0005: 'LB0005',
} as const;

export type ErrorCodeType = (typeof ErrorCode)[keyof typeof ErrorCode];

export const HSG_SCREENING_CODE = {
  BREAST_CANCER: 'BREAST_CANCER',
  CARDIOVASCULAR: 'CARDIOVASCULAR',
  CERVICAL_HPV: 'CERVICAL_HPV',
  CERVICAL_PAP: 'CERVICAL_PAP',
  COLORECTAL_CANCER: 'COLORECTAL_CANCER',
} as const;

export const HSG_SCREENING_STATUS = {
  APPOINTMENT_MADE: 'APPOINTMENT_MADE',
  AVAILABLE_ON: 'AVAILABLE_ON',
  GO_SCREENING: 'GO_SCREENING',
  NOT_AVAILABLE: 'NOT_AVAILABLE',
  PENDING_RESULTS: 'PENDING_RESULTS',
  READY_BOOK: 'READY_BOOK',
  RESULTS_READY: 'RESULTS_READY',
};

export const HEALTH_SCREENING_RESULT_CODE = {
  BMI: 'BMI',
  BLOOD_PRESSURE: 'BloodPressure',
  BLOOD_GLUCOSE: 'BloodGlucose',
  BLOOD_CHOLESTEROL: 'BloodCholesterol',
};

export const HEALTH_SCREENING_RESULT_SUB_CODE = {
  SYSTOLIC: 'Systolic',
  DIASTOLIC: 'Diastolic',
  FASTING_HBA1C: 'FastingHbA1c',
  NON_FASTING_HBA1C: 'NonFastingHbA1c',
  FASTING_VENOUS_GLUCOSE: '1FVG',
  FASTING_VENOUS_GLUCOSE_SECOND: '2FVG',
  OGGT_FASTING_GLUCOSE: 'OFG0',
  OGGT_FASTING_GLUCOSE2H: 'OFG2',
  TOTAL_CHOLESTEROL: 'TotalCholesterol',
  HDL_CHOLESTEROL: 'HdlCholesterol',
  LDL_CHOLESTEROL: 'LdlCholesterol',
  TRIGLYCERIDES: 'Triglycerides',
};

export type HsgScreeningStatusType = (typeof HSG_SCREENING_STATUS)[keyof typeof HSG_SCREENING_STATUS];

export const HSG_SCREENING_QUESTION_INFO = {
  SCREEN: 'screen',
  TESTED: 'tested',
};

export type HsgScreeningQuestionInfoType =
  (typeof HSG_SCREENING_QUESTION_INFO)[keyof typeof HSG_SCREENING_QUESTION_INFO];

export const SCREENING_VIEW = {
  HEALTHIERSG: 'healthiersg',
  HEALTH_SCREENING: 'healthSscreening',
};

export const HsgDashBoardToastBoxText = {
  IMMUNISATION_RECORDS: 'Immunisation Records',
  QUESTIONNAIRES: 'Questionnaires',
} as const;

export type HsgDashBoardToastBoxText = (typeof HsgDashBoardToastBoxText)[keyof typeof HsgDashBoardToastBoxText];

export const HSG_BEFORE_CARE_MESSAGE_MMG_NUP = 'Appointment.HSG.BeforeCareMessage.Mammogram.NUP';
export const HSG_BEFORE_CARE_MESSAGE_MMG_NHGP = 'Appointment.HSG.BeforeCareMessage.Mammogram.NHGP';

export const HSG_DASHBOARD_TOOL_TYPES = {
  H365: 'H365',
  SMOKING: 'Smoking',
};

export type HsgDashboardToolType = (typeof HSG_DASHBOARD_TOOL_TYPES)[keyof typeof HSG_DASHBOARD_TOOL_TYPES];
